import currencyEnums from 'enums/currencies';

export function getCurrencySymbol(currency) {
  switch (currency) {
    case currencyEnums.CURRENCIES.USD:
      return '$';
    default:
      return '$';
  }
}

export function getCurrencyAmount(currency, monetaryUnit = 0) {
  switch (currency) {
    case currencyEnums.CURRENCIES.USD:
      return monetaryUnit / 100;
    default:
      return monetaryUnit / 100;
  }
}

export function getFormattedCurrencyAmount(currency, monetaryUnit) {
  switch (currency) {
    case currencyEnums.CURRENCIES.USD:
      return getCurrencySymbol(currency) + getCurrencyAmount(currency, monetaryUnit);
    default:
      // default to putting currency symbol before amount
      return getCurrencySymbol(currency) + getCurrencyAmount(currency, monetaryUnit);
  }
}
